import { ThemeConfig } from "antd";
import colors from "./colors";

export const antdThemeConfig: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorPrimaryText: colors.header,
    colorBorder: colors.light,
    fontFamily: "Inter",
    colorBgContainerDisabled: colors.primary,
  },
  components: {
    Button: {
      borderRadius: 6,
      controlHeight: 36,
      controlHeightSM: 32,
      borderRadiusSM: 6,
      borderRadiusLG: 6,
      controlHeightLG: 48,
      paddingContentHorizontalLG: 15,
      paddingContentHorizontal: 10,
    },
    Form: {
      colorError: colors.error,
    },
    Input: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.bodyText,
    },
    InputNumber: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.bodyText,
    },
    Select: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorErrorBorder: colors.error,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.bodyText,
    },
    DatePicker: {
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.bodyText,
    },
    Checkbox: {
      colorText: colors.displayBody,
      colorBorder: colors.displayMedium,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.bodyText,
    },
    Badge: {
      lineWidth: 1.5,
    },
    Menu: {
      itemMarginBlock: 4,
      itemMarginInline: 0,
    },
    Table: {
      borderRadiusLG: 0,
      fontSize: 14,
      colorTextHeading: colors.header,
      colorText: colors.bodyText,
      colorBorderSecondary: colors.light, // Table Border Color
      colorBgContainer: "white",
      padding: 12,
    },
    Pagination: {
      itemActiveBg: colors.primary,
      itemSize: 32,
      borderRadius: 4,
      colorText: colors.displayBody,
      fontSize: 13,
    },
  },
};

export const quillToolbarFormats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "color",
  "code-block",
  "formula",
  "direction",
  "code",
  "undo",
  "redo",
  "emoji",
];

export const quillToolbarModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    // [{ list: "ordered" }, { list: "bullet" }],
    [{ list: "bullet" }],
    ["link", "image", "video"],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ size: [] }],
    // [{ undo: "undo" }, { redo: "redo" }],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    // [{ indent: "-1" }, { indent: "+1" }],
    // [{ direction: "rtl" }],
    [{ align: [] }],
    // ["blockquote", "code-block"],
    // ["formula"],
    // ["emoji"],
  ],
  // emoji: {
  //   emojiList,
  //   buttonIcon: "🙂",
  // },

  history: {
    delay: 1000,
    maxStack: 50,
    userOnly: true,
  },
};
